import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';

class Highlight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      timeout: null,
    };
    this.onEntered = this.onEntered.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  componentDidMount() {
    this.setState({ show: false });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.children !== newProps.children) {
      this.setState({ show: false });
    }
  }

  onEntered() {
    this.setState({ show: false, timeout: 200 }, () => {
      this.onExited();
    });
  }

  onExited() {
    this.setState({ show: true });
  }

  defaultStyle() {
    const { duration } = this.props;
    return {
      transition: `all ${duration}ms ease-in-out`,
      color: 'inherit',
    };
  }

  transitionStyles() {
    const { defaultColor, highlightColor } = this.props;
    return {
      entering: { color: [defaultColor] || 'inherit' },
      entered: { color: [highlightColor] || '#000' },
      exiting: { color: [highlightColor] || '#000' },
      exited: { color: [defaultColor] || 'inherit' },
    };
  }

  render() {
    const { children, timeout } = this.props;
    return (
      <Transition
        in={!this.state.show}
        timeout={this.state.timeout || timeout}
        onEntered={this.onEntered}
      >
        {(state) => (
          <div
            style={{
              ...this.defaultStyle(),
              ...this.transitionStyles()[state],
            }}
          >
            {children}
          </div>
        )}
      </Transition>
    );
  }
}

Highlight.defaultProps = {
  timeout: 1000,
  duration: 200,
  highlightColor: '#000',
};

Highlight.propTypes = {
  duration: PropTypes.number,
  timeout: PropTypes.number,
  highlightColor: PropTypes.string,
  children: PropTypes.any,
  defaultColor: PropTypes.string,
};

export default Highlight;
